<template>
  <div>
    <section>
      <div class="title-block">発着照会追加</div>
      <div class="text-block" style="text-align: left; margin-left: 6px">
        新宿ー町田、新宿ー相模大野の空席情報を同時に検索したい場合等にご利用ください。
      </div>
      <div class="column">
        <div class="radio-wrap">
          <div class="radio">
            <input
              id="radio-1"
              name="radio"
              type="radio"
              :value="0"
              v-model="addInquiryRadio"
            />
            <label for="radio-1" class="radio-label">無し</label>
          </div>
          <div class="radio">
            <input
              id="radio-2"
              name="radio"
              type="radio"
              :value="1"
              v-model="addInquiryRadio"
            />
            <label for="radio-2" class="radio-label">発駅</label>
          </div>
          <div class="radio">
            <input
              id="radio-3"
              name="radio"
              type="radio"
              :value="2"
              v-model="addInquiryRadio"
            />
            <label for="radio-3" class="radio-label">着駅</label>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label>駅名</label>
          <div class="select-wrap">
            <select
              class="form-control"
              v-model="addInquiryStation"
              :disabled="addInquiryRadio == 0"
            >
              <!-- stationsをループ表示 -->
              <option
                v-for="(station, index) in props.stations"
                :key="index"
                :value="station"
              >
                {{ station.name }}
              </option>
            </select>
          </div>
        </div>
        <p v-if="!props.isValidAddInquiryStation" class="warning-block">
          ※区間で選択した{{
            addInquiryRadio == 1 ? "出発駅" : "到着駅"
          }}と異なる駅を選択してください
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingAddInquiry",
  props: {
    stations: {
      type: Array,
      required: true,
    },
    addInquiryRadio: {
      type: Number,
      required: true,
    },
    addInquiryStation: {
      type: Object,
      required: true,
    },
    isValidAddInquiryStation: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const addInquiryRadio = useVModel(props, "addInquiryRadio");
    const addInquiryStation = useVModel(props, "addInquiryStation");

    return {
      addInquiryRadio,
      addInquiryStation,
      props,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.warning-block {
  margin: 10px 6px;
  text-align: right;
  font-size: 12px;
  color: #ed2323;
}

.float-text {
  float: right;
  font-weight: normal;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}

.field {
  position: relative;
  margin: 0 0 0 0;
}

.field label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}
.text-block {
  text-align: right;
  font-size: 13px;
  line-height: 18px;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 150px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}
.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 3vw;
  margin-top: -4px;
}

/* ラジオボタン */
.radio-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px;
}
.radio-wrap {
  justify-content: space-between;
}
.radio {
  margin: 0.5rem !important;
}
.radio input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.radio input[type="radio"] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.2em;
  margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type="radio"]:checked + .radio-label:before {
  background-color: #ff7600;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type="radio"]:focus + .radio-label:before {
  outline: none;
  border-color: #ff7600;
}
.radio input[type="radio"]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type="radio"] + .radio-label:empty:before {
  margin-right: 0;
}
</style>
